import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import { AnimatePresence, motion } from 'framer-motion'
import { useMediaQuery } from 'react-responsive'
import { DialogOverlay, DialogContent } from '@reach/dialog'
import '@reach/dialog/styles.css'
import { FiX, FiMoreVertical } from 'react-icons/fi'

export const AdminPanel = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding-bottom: 100px;
`

export const H1 = styled.h1`
  font-size: 2rem;
  line-height: 50px;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;

  ${(props) =>
    props.small &&
    css`
      font-size: 1.5rem;
    `}

  ${(props) => props.theme.media.phone`
    ${(props) =>
      props.mobileCenter &&
      css`
        text-align: center;
        justify-content: center;
      `}
  `}
`

export const H2 = styled.h2`
  font-size: 1.1rem;
`

export const AdminSplit = styled.div`
  margin: 40px auto;
  display: flex;
  flex-direction: row;
  padding-bottom: 40px;
  border-bottom: #eee solid 2px;
  ${(props) =>
    props.borderTop &&
    css`
      border-top: #eee solid 2px;
      padding-top: 40px;
    `}

  ${(props) => props.theme.media.phone`
    flex-direction: column;
  `}
`

export const AdminLeft = styled.div`
  width: 40%;
  padding-right: 20px;

  ${(props) => props.theme.media.phone`
    width: 100%;
    padding-right: 0;
  `}
`

export const AdminRight = styled.div`
  width: 60%;

  ${(props) => props.theme.media.phone`
      width: 100%;
  `}
`

export const AdminCard = styled.div`
  border-radius: 10px;
  border: ${(props) => props.theme.colors.adminBorder} solid 2px;
  padding: 20px;
`

export const AdminFilters = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 20px;

  ${(props) => props.theme.media.phone`
    flex-wrap: nowrap;
    gap: 5px;
  `}
`

export const FilterColumn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;

  ${(props) => props.theme.media.phone`
    flex-wrap: wrap;
    width: 100%;
  `}
`

export const ButtonModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const MoreButton = styled.button`
  border: 0;
  background-color: ${(props) => props.theme.colors.adminBlue};
  color: #fff;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 2px 10px;
  line-height: inherit;

  &:hover {
    opacity: 0.75;
    transition: all 0.25s;
  }

  svg {
    height: 15px;
    width: 15px;
    color: ${(props) => props.theme.colors.white};
  }
`

export const CloseButton = styled.button`
  background-color: transparent;
  border: 0;
  position: absolute;
  top: 20px;
  right: 20px;

  svg {
    height: 30px;
    width: 30px;
  }
`

export const ActionColumn = ({ collapse = false, children }) => {
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` })
  const [showDialog, setShowDialog] = useState(false)
  const open = () => setShowDialog(true)
  const close = () => setShowDialog(false)
  const renderChildren = () => {
    if (typeof children === 'function') {
      return children({ open, close })
    } else {
      return children
    }
  }
  if (isMobile || collapse) {
    return (
      <div>
        <MoreButton onClick={open}>
          {!isMobile && 'Actions'} &nbsp; <FiMoreVertical />
        </MoreButton>
        <AnimatePresence>
          {showDialog && (
            <DialogOverlay
              isOpen={showDialog}
              onDismiss={close}
              style={{ zIndex: 100002 }}
            >
              <DialogContentStyled
                aria-label="Modal"
                initial={{ bottom: -200 }}
                animate={{ bottom: 0 }}
                exit={{ bottom: -200 }}
              >
                <CloseButton onClick={close}>
                  <FiX />
                </CloseButton>
                <ButtonModal>{renderChildren()}</ButtonModal>
              </DialogContentStyled>
            </DialogOverlay>
          )}
        </AnimatePresence>
      </div>
    )
  } else {
    return <FilterColumn>{renderChildren()}</FilterColumn>
  }
}

const MotionDialogContent = motion(DialogContent)

const DialogContentStyled = styled(MotionDialogContent)`
  position: fixed;
  width: 100vw;
  margin-bottom: 0;
  padding: 20px;
  bottom: 0;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 15px 25px,
    rgba(0, 0, 0, 0.05) 0px 5px 10px;
  display: flex;
  justify-content: center;
`

export const RightFullHeight = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`
